<template>
    <v-dialog v-model="linkedin_auth" persistent width="300">
          <v-card color="primary" dark>
            <v-card-text>
              Logging in...
              <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
          </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios';

export default {
    name: 'LinkedInAuth',
    data() {
        return {
            linkedin_code: null,
            linkedin_state: null,
            linkedin_auth: true
        }
    },
    created() {
        this.linkedin_code = this.$route.query.code
        this.linkedin_state = this.$route.query.state
        //console.log(window.close());
        this.get_linkedin_token()
    },
    methods: {
        get_linkedin_token() {
            let post_json = {
                "provider": "linkedin",
                "redirect_uri": `${window.location.origin}/linkedin/callback`,
                "action": "access_token",
                "authorization_code": this.linkedin_code,
                "state": this.linkedin_state
            }

            axios.post(`https://${this.$buyerAPI}/auth?action=access_token`, post_json)
            .then((resp) => {
                let token = resp.data.data.token;
                let ispassword = true;
                this.$store.dispatch('linkedin_login', {token, ispassword})
                .then(() => {
                    this.$router.push("/")
                })
                .catch(() => {
                    this.$router.push("/login")
                })
            })
            .catch(() => {
                this.$router.push("/login")
            })
        }
    }
}
</script>
